import { apiFetch } from '@/lib/api'
import type { components } from '@/types/api'

export type FxRates = components['schemas']['FxRates']

/** TCMB döviz satış (`rates`) ve alış (`buying_rates`) kurları (backend saatlik önbellekler). */
export function fetchFxRates(): Promise<FxRates> {
  return apiFetch<FxRates>('/fx/rates')
}
